import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import { c as classNames } from './bind-a2a3a613.js';
import { KeyboardKey } from '../constants/keyboard.js';
import { onA11yKeyDown } from '../utils/a11y/onA11yKeyDown.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "tabs": "web_ui__Tabs__tabs",
  "title": "web_ui__Tabs__title",
  "tab": "web_ui__Tabs__tab",
  "tab-content": "web_ui__Tabs__tab-content",
  "is-active": "web_ui__Tabs__is-active",
  "allow-overflow": "web_ui__Tabs__allow-overflow",
  "content": "web_ui__Tabs__content",
  "wide": "web_ui__Tabs__wide",
  "parent": "web_ui__Tabs__parent",
  "divider": "web_ui__Tabs__divider"
};

var cssClasses = classNames.bind(styles);
var TabTitle = function TabTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx("span", {
    className: styles.title,
    children: children
  });
};
var Tab = function Tab(_ref2) {
  var item = _ref2.item,
    role = _ref2.role,
    onClick = _ref2.onClick,
    isActive = _ref2.isActive,
    testId = _ref2.testId;
  var handleClick = function handleClick(event) {
    if (!onClick) return;
    onClick(item, event);
  };
  var handleKeyDown = function handleKeyDown(event) {
    onA11yKeyDown(event, {
      keys: [KeyboardKey.Enter, KeyboardKey.Space]
    });
  };
  var tabClasses = cssClasses('tab', {
    'is-active': isActive
  }, {
    'allow-overflow': !!item.contentExperimental
  });
  var tabAccessibilityProps = role === 'tab' ? {
    role: 'tab',
    'aria-selected': isActive,
    tabIndex: 0
  } : {
    role: 'menuitem',
    tabIndex: 0
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    jsxs("li", _objectSpread(_objectSpread(_objectSpread({}, item.aria), {}, {
      id: item.id.toString(),
      className: tabClasses,
      onClick: onClick ? handleClick : undefined,
      onKeyDown: onClick ? handleKeyDown : undefined,
      "data-testid": testId
    }, tabAccessibilityProps), {}, {
      children: [item.children ? item.children : /*#__PURE__*/jsx(TabTitle, {
        children: item.title
      }), item.contentExperimental ? /*#__PURE__*/jsx("div", {
        className: cssClasses('tab-content'),
        children: item.contentExperimental
      }) : null]
    }))
  );
};

export { TabTitle as T, Tab as a, styles as s };
//# sourceMappingURL=Tab-9c42c804.js.map
